export class CreateSigningActionDto {

  "documentIds": string[];
  "signingUrl": string;

  constructor(data: any) {
    this.documentIds = data.documentIds;
    this.signingUrl = data.signingUrl;
  }
}
